// This file was automatically generated from ext.onboarding.noProfileDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ext.onboarding.noProfileDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.noProfileDialog.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PromptDialogContainer"><h1 class="el8PageTitle">Please Contact Us</h1><p>We apologize for the difficulty you are experiencing in finding your profile.</p><p class="spacer">Please send us an email at <a href="mailto:', soy.$$escapeHtml(opt_data.supportEmail), '">', soy.$$escapeHtml(opt_data.supportEmail), '</a> or call us at ', soy.$$escapeHtml(opt_data.supportPhone), ', and we will set up an account for you right away.</p></div>');
  if (!opt_sb) return output.toString();
};
